import { render, staticRenderFns } from "./CheckResultDisplay.vue?vue&type=template&id=034d2fae&scoped=true&"
import script from "./CheckResultDisplay.vue?vue&type=script&lang=js&"
export * from "./CheckResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CheckResultDisplay.vue?vue&type=style&index=0&id=034d2fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d2fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034d2fae')) {
      api.createRecord('034d2fae', component.options)
    } else {
      api.reload('034d2fae', component.options)
    }
    module.hot.accept("./CheckResultDisplay.vue?vue&type=template&id=034d2fae&scoped=true&", function () {
      api.rerender('034d2fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/CheckingManager/CheckResultDisplay.vue"
export default component.exports